/** Thai strings for this area (English source text -> Thai): age screen, parent gate, stationery shop. */
export const FAMILY: Record<string, string> = {
  // Age screen and parent gate (ui/family)
  'Year you were born': 'ปีเกิด (พ.ศ.)',
  'Pick a year': 'เลือกปี',
  'Before you open your notebook: what year were you born?': 'ก่อนเปิดสมุด บอกหน่อยว่าเกิดปีไหน?',
  'Welcome to Paper Legends!': 'ยินดีต้อนรับสู่ Paper Legends!',
  Continue: 'ต่อไป',
  'Pick the year you were born to continue.': 'เลือกปีเกิดก่อนนะ ถึงจะไปต่อได้',
  Answer: 'คำตอบ',
  'Grown-ups only: what is {a} times {b}?': 'สำหรับผู้ใหญ่: {a} คูณ {b} ได้เท่าไร?',
  'Ask a grown-up': 'ให้ผู้ใหญ่ช่วยหน่อย',
  'Changing the age setting needs a grown-up.': 'การเปลี่ยนอายุต้องให้ผู้ใหญ่เป็นคนทำ',
  'That answer was not right. Ask a grown-up to help.': 'คำตอบยังไม่ถูก ให้ผู้ใหญ่ช่วยนะ',

  // Settings → Family, Friends (kid names)
  Family: 'ครอบครัว',
  'Age: 18 or older.': 'อายุ: 18 ปีขึ้นไป',
  'Age: 13 to 17. A grown-up approves any real-money purchase.': 'อายุ: 13–17 ปี การซื้อด้วยเงินจริงต้องให้ผู้ปกครองอนุมัติ',
  'Kid mode (under 13): the game picks your online name, and a grown-up approves any real-money purchase.':
    'โหมดเด็ก (ต่ำกว่า 13 ปี): เกมตั้งชื่อออนไลน์ให้ และการซื้อด้วยเงินจริงต้องให้ผู้ปกครองอนุมัติ',
  'Change age': 'เปลี่ยนอายุ',
  'In kid mode the game picks your online name, so it is always friendly.': 'ในโหมดเด็ก เกมจะตั้งชื่อออนไลน์ให้ เพื่อให้เป็นชื่อที่น่ารักเสมอ',

  // Stationery shop (Gear tab)
  'Stationery Shop': 'ร้านเครื่องเขียน',
  'Looks only: new ink for your drawings and stamps for your wins. They never change battle stats.':
    'ของแต่งล้วนๆ: หมึกสีใหม่ไว้วาดรูป และตราประทับตอนชนะ ไม่เปลี่ยนพลังในการสู้เลย',
  'Gel Pens': 'ปากกาเจล',
  'Victory Stamps': 'ตราประทับตอนชนะ',
  'IN YOUR PENCIL CASE': 'อยู่ในกล่องดินสอแล้ว',
  'Take off': 'เลิกใช้',
  Use: 'ใช้',

  // Cosmetics (game/data/cosmetics)
  'Mint Gel Pen': 'ปากกาเจลสีมิ้นต์',
  'Cool minty ink for slimes and ghosts.': 'หมึกสีมิ้นต์เย็นๆ เหมาะกับสไลม์และผี',
  'Coral Gel Pen': 'ปากกาเจลสีปะการัง',
  'Warm coral ink, great for dragons.': 'หมึกสีส้มปะการัง วาดมังกรเท่สุดๆ',
  'Lavender Gel Pen': 'ปากกาเจลสีลาเวนเดอร์',
  'Soft purple ink for magic sparkles.': 'หมึกม่วงอ่อน ไว้วาดประกายเวทมนตร์',
  'Sky Gel Pen': 'ปากกาเจลสีฟ้า',
  'Light blue ink for skies and water.': 'หมึกฟ้าอ่อน ไว้วาดท้องฟ้ากับน้ำ',
  'Navy Ballpoint': 'ปากกาลูกลื่นสีกรม',
  'Deep blue ink, like the back page of every notebook.': 'หมึกน้ำเงินเข้ม เหมือนหน้าหลังสมุดทุกเล่ม',
  'Lime Highlighter': 'ปากกาไฮไลต์สีมะนาว',
  'Neon lime that pops off the page.': 'สีเขียวมะนาวสะท้อนแสง เด่นสุดในหน้า',
  'Gold Glitter Pen': 'ปากกากากเพชรสีทอง',
  'Shiny gold for crowns and treasure.': 'สีทองวิบวับ ไว้วาดมงกุฎกับสมบัติ',
  'Silver Glitter Pen': 'ปากกากากเพชรสีเงิน',
  'Shiny silver for swords and robots.': 'สีเงินวิบวับ ไว้วาดดาบกับหุ่นยนต์',
  'A+ Stamp': 'ตราประทับ A+',
  "The teacher's best grade, on every win.": 'เกรดสูงสุดจากครู ประทับทุกครั้งที่ชนะ',
  'A+': 'A+',
  'Well Done Stamp': 'ตราประทับ "เก่งมาก"',
  'A big green WELL DONE on every win.': 'คำว่า "เก่งมาก" สีเขียวตัวโต ทุกครั้งที่ชนะ',
  'WELL DONE!': 'เก่งมาก!',
  'Gold Star Stamp': 'ตราประทับดาวทอง',
  'A shiny gold star on every win.': 'ดาวทองวิบวับ ทุกครั้งที่ชนะ',
  '★ GOLD STAR ★': '★ ดาวทอง ★',
  'Homework Done Stamp': 'ตราประทับ "ส่งการบ้านแล้ว"',
  'Blue ink that says the homework is finished.': 'หมึกน้ำเงินบอกว่าทำการบ้านเสร็จแล้ว',
  'HOMEWORK DONE': 'ส่งการบ้านแล้ว',
  'Legend Stamp': 'ตราประทับตำนาน',
  'For true paper legends only.': 'สำหรับตำนานแห่งสมุดตัวจริงเท่านั้น',
  'LEGEND!': 'ตำนาน!',
};
